import React, { useMemo } from 'react'
import { Text } from '@leverege/ui-elements'
import OrganizeAttrs from './OrganizeAttrs'
import AttributeView from './AttributeView'

export default function RelationshipAttributeView( props ) {

  const { blueprint, tags } = props

  const organizeAttrs = useMemo( () => {
    let r = blueprint.attributes || []
    if ( tags.length > 0 ) {
      r = r.filter( ( a ) => {
        return tags.some( ( t ) => { return a.path.indexOf( t ) >= 0 || a.name.indexOf( t ) >= 0 } )
      } )
    }
    const o = OrganizeAttrs.organizeAttrs( r )
    o.relationships.sort( ( a, b ) => {
      const aName = `${a.type}:${a.name.toLowerCase()}`
      const bName = `${b.type}:${b.name.toLowerCase()}`
      return aName.localeCompare( bName )
    } )
    return o
  }, [ blueprint.attributes, tags ] )
  const pRel = organizeAttrs.relationships.filter( r => r.type === 'parentRelationship' )
  const rRel = organizeAttrs.relationships.filter( r => r.type === 'relationship' )
  return (
    <div>
      {pRel.length > 0 && <Text variant="screenTitle">Parent Relationships</Text>}
      {pRel.length > 0 && pRel.map( ( rel, i ) => {
        return (
          <AttributeView {...props} node={rel} key={rel.path} />
        )
      } ) }
      {pRel.length > 0 && <Text variant="screenTitle">&nbsp;</Text>}

      {rRel.length > 0 && <Text variant="screenTitle">Relationships</Text>}
      {rRel.length > 0 && rRel.map( ( rel, i ) => {
        return (
          <AttributeView {...props} showName={false} node={rel} key={rel.path} />
        )
      } ) }
    </div>
  )

}
